/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Min/max range configuration for Arena settings
 * @export
 * @interface ArenaRangeConfig
 */
export interface ArenaRangeConfig {
    /**
     * Minimum value
     * @type {number}
     * @memberof ArenaRangeConfig
     */
    min?: number;
    /**
     * Maximum value
     * @type {number}
     * @memberof ArenaRangeConfig
     */
    max?: number;
}

/**
 * Check if a given object implements the ArenaRangeConfig interface.
 */
export function instanceOfArenaRangeConfig(value: object): value is ArenaRangeConfig {
    return true;
}

export function ArenaRangeConfigFromJSON(json: any): ArenaRangeConfig {
    return ArenaRangeConfigFromJSONTyped(json, false);
}

export function ArenaRangeConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArenaRangeConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'min': json['min'] == null ? undefined : json['min'],
        'max': json['max'] == null ? undefined : json['max'],
    };
}

export function ArenaRangeConfigToJSON(json: any): ArenaRangeConfig {
    return ArenaRangeConfigToJSONTyped(json, false);
}

export function ArenaRangeConfigToJSONTyped(value?: ArenaRangeConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'min': value['min'],
        'max': value['max'],
    };
}

